export default "__VITE_ASSET__622f7208__"